import { createFeatureSelector, createSelector } from '@ngrx/store';
import { REPORT_CLONE_FEATURE_KEY, ReportCloneState, selectEntities } from './report-clone.reducer';

// Lookup the 'ReportClone' feature state managed by NgRx
export const reportCloneState = createFeatureSelector<ReportCloneState>(REPORT_CLONE_FEATURE_KEY);

export const reportCloneEntities = createSelector(reportCloneState, (state) => state.reportCloneEntities);

export const reportCloneStateEntities = createSelector(reportCloneEntities, selectEntities);

export const reportCloneLoaded = (reportId: string) =>
  createSelector(reportCloneStateEntities, (reportCloneEntities) => reportCloneEntities?.[reportId]?.loaded);

export const progressToastId = (reportId: string) =>
  createSelector(reportCloneStateEntities, (reportCloneEntities) => reportCloneEntities?.[reportId]?.progressToastId);

export const recentlyClonedReport = createSelector(reportCloneState, (state) => state?.recentlyClonedReport);
